export interface LastBookOrder {
  bid: string;
  title: string;
  category: string;
}
